import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Typography } from '@mui/material';

export default function StaticTableCellItem({ text }: { text: string }) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Typography
      sx={{ p: sp.s30, display: 'flex', width: 1, whiteSpace: 'pre-line' }}
      variant="f16"
    >
      {text}
    </Typography>
  );
}
